// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: #27AE60;
    color: #FFF;
    border-top: 50px;
}

.footer p {
    font-size: 0.9rem;
    color: #FFF
}
.footer a {
    color: #FFF;
    font-weight: 600;
    text-decoration: none;
}

.footer a:hover {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/css/sg-footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB;AACJ;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".footer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 50px;\n    background-color: #27AE60;\n    color: #FFF;\n    border-top: 50px;\n}\n\n.footer p {\n    font-size: 0.9rem;\n    color: #FFF\n}\n.footer a {\n    color: #FFF;\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.footer a:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
